export default __webpack_public_path__ + "static/media/Hubspot.688ee6c3.svg";